"use client";
import "../../chunk-MMUBH76A.js";
const DEFAULTS = {
  LOGGIN_POLLING_DELAY_MS: 5e3,
  POLLING_INTERVAL_MS: 2e3,
  ANIMATION_DURATION: 0.15
};
export {
  DEFAULTS
};
